module.exports = __webpack_public_path__ + "static/media/boldGoldFrame.729d0fc9.png";